<template>
    <div class="ui left rail hideOnMobileSite" style="left:20px;z-index:1;">
      <div class="ui xstickyx">
       <div class="ui list">
        <a class="item"
            v-for="i in wdInfo"
            v-if="isMenuEntryVisible(i.id)"
            @click.prevent="scrollTo(i.id)">
          <i v-if="wdNewErrorCounts[i.id]>0" :class="'large '+i.icon+' icon'" :style="'padding:'+i.padding+';color:brown;position:relative;'">
            <div>{{wdNewErrorCounts[i.id]}}</div>
          </i>
          <i v-else :class="'large '+i.icon+' icon'" :style="'padding:'+i.padding+';color:grey;'"></i>
          <div class="content">
            <span class="header">{{i.name}}</span>
          </div>
        </a>
       </div>
       <div style="display:none;">{{wdMenuUpdateTrigger}}</div>
      </div>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
  data: function () {
    return {
      wdInfo: [
        {'icon': 'warehouse', 'id': 'inventory', 'name': 'FBA Stock', 'padding': '0 3px'},
        {'icon': 'warehouse', 'id': 'fbmInventory', 'name': 'FBM Stock', 'padding': '0 3px'},
        {'icon': 'unordered list', 'id': 'productDetailsRecentChange', 'name': 'Product Details Change', 'padding': '5px 6px 0 6px'},
        {'icon': 'image', 'id': 'imageMissing', 'name': 'Main Image', 'padding': '0 6px'},
        {'icon': 'unordered list', 'id': 'productCategoryRecentChange', 'name': 'Category Change', 'padding': '0 6px'},
        {'icon': 'trophy', 'id': 'bestSellerBadge', 'name': 'Best Seller Badge', 'padding': '0 5px'},
        {'icon': 'check', 'id': 'prime', 'name': 'Prime Badge', 'padding': '0 7px'},
        {'icon': 'bookmark', 'id': 'amazonChoiceBadge', 'name': 'Amazon\'s choice Badge', 'padding': '0 7px'},
        {'icon': 'sync', 'id': 'subscribeAndSave', 'name': 'Subscribe And Save', 'padding': '0 5px'},
        {'icon': 'sitemap', 'id': 'parentProductChange', 'name': 'Parent Product Change', 'padding': '0 5px'},
        {'icon': 'eye slash', 'id': 'adultClassification', 'name': 'Adult Classification', 'padding': '0 5px'},
        {'icon': 'dollar sign', 'id': 'price', 'name': 'Price Change', 'padding': '0px 11px 0px 8px'},
        {'icon': 'user secret', 'id': 'numberOfSellers', 'name': 'Hijacker Alert', 'padding': '0px 7px 0px 7px'},
        {'icon': 'add to cart', 'id': 'lostBuybox', 'name': 'Buy-box', 'padding': '0px 7px 0px 2px'},
        {'icon': 'add to cart', 'id': 'noAddToCart', 'name': 'Add-to-Cart Button', 'padding': '0px 7px 0px 2px'},
        {'icon': 'line chart', 'id': 'salesDrop', 'name': 'Sales Volume', 'padding': '0 6px'},
        {'icon': 'dolly flatbed', 'id': 'fbaFeeChange', 'name': 'FBA Fee Change', 'padding': '0px 3px 0px 1px'},
        {'icon': 'warning sign', 'id': 'listingSuspended', 'name': 'Suspended Listings', 'padding': '0 5px'},
        {'icon': 'search minus', 'id': 'searchBan', 'name': 'Search Result Suppression', 'padding': '0 5px'},
        {'icon': 'comment alternate', 'id': 'badReview', 'name': 'Latest Reviews', 'padding': '0 4px'},
        {'icon': 'comment alternate', 'id': 'topReview', 'name': 'Top Rated Reviews', 'padding': '0 4px'},
        {'icon': 'star', 'id': 'starRatingRecentChange', 'name': 'Star Rating', 'padding': '0 4px 0 5px'},
        {'icon': 'comment alternate outline', 'id': 'badSellerFeedback', 'name': 'Bad Seller Fback', 'padding': '0 5px'},
        // {'icon': 'search', 'id': 'keyword', 'name': 'Search Rank', 'padding': '0 5px'},
      ],
    }
  },
  props: ['wdNewErrorCounts', 'wdMenuUpdateTrigger'],
  methods: {
    scrollTo: function (wdtype) {
      const el = $('[data-wdtype=' + wdtype + ']')[0]
      // const topOfPage = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const heightOfPage = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      const elH = el.offsetHeight
      let elY = 0; for (let p = el; p && p.tagName !== 'BODY'; p = p.offsetParent) { elY += p.offsetTop }
      $('body,html').stop().animate({scrollTop: elY - ((heightOfPage - elH) / 2)}, 450)
    },
    isMenuEntryVisible: function (wdtype) {
      try {
        return this.$parent.$parent.worldStore.watchDogs[wdtype].status !== 21
      } catch (err) {
        return true
      }
    },
  },
  // computed: {},
  mounted: function () {
    // sticky JS is now replaced with pure css
    // $('.ui.sticky').sticky({context: '#context'})
    // setInterval(() => $('.ui.sticky').sticky('refresh'), 1111) // because it is stupid... after any change in any WD box size it needs to recalculate its dimension limits. It is way more efficient though constantly checking onscroll, smoother too. So guess it is ok, just looks ugly.
  },
  watch: {
    wdnewerrorcounts: function () { console.log('valt') }
  },
}
</script>

<style>
.xstickyx {position: -webkit-sticky; position: sticky; top: 10px; max-height: calc(100vh - 20px);}

.xstickyx .item:hover .icon div {display:block;}
.xstickyx .icon div {
  display: none;
  position: absolute;
  color: #fff;
  font-size: 10px;
  top: -3px;
  left: 0px;
  background: rgba(22,22,22,.75);
  border-radius: 3px;
  font-family: arial;
  padding: 2px;
}
#wdCont .xstickyx > .list {
  max-height: inherit;
  width: 180px;
  margin-top: 10px;
  padding: 5px 10px 5px 5px;
  border-radius: 8px;
  background: rgba(1,1,1,0.1);
  overflow: hidden;
}

#wdCont .xstickyx > .list:hover {
  padding-right: 0px;
  overflow: auto;
}
#wdCont .xstickyx .list>.item {padding: 8px 1px;}
#wdCont .xstickyx .item .header {margin-top: 3px;}
#wdCont .xstickyx .item .content {padding-left: 5px;}

</style>



// WEBPACK FOOTER //
// WatchdogMenu.vue?09441377